import React, { useEffect, useState } from "react";
import { Container, Form, ModalBody, ModalHeader} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import NewPagination from "components/Common/Newpagination";
import "../../../assets/css/Sales/Sales.css";
import "../../../assets/css/Sales/Proposal.css";
import Loader from "pages/Separate/Loader";
import configure from "configure";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import "../../../assets/css/Work/projects.css";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import Swal from "sweetalert2";
import secureLocalStorage from "react-secure-storage";
import { fetchData, FetchPostData } from "utils/common-fetchData";
import AddTask from "./common/AddTask";
import { MaintenanceProjectColumns } from "utils/columns/Developement/projectColunmn";
import { checkPermissionsByModule } from "utils/common-helpers";
import { useSelector } from "react-redux";
import ActivityLog from "./EditProject/ActivityLog";
import Milestones from "./EditProject/Milestones";
import Notes from "./EditProject/Notes";
import ViewTasks from "./ViewProject/ViewTasks";
import ProjectOverview from "./EditProject/ProjectOverview";
import Credential from "./EditProject/Credential";
import Select from "react-select"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import moment, { months } from "moment"
import axios from "axios"
import { colourStyles } from "utils/common-options"

function TableContainer({
  columns,
  data,
  setData,
  allData,
  setAccessDenied,
  roles,
}) {
  const [fixedContent, setFixedContent] = useState(false);
  const navigate = useNavigate();
   const [isOpen, setOpen] = useState(false)
  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => setPageSize(50), []);
  const [status, setStatus] = useState("in-progress");
  useEffect(() => {
    setData(allData?.filter((obj) => obj.status == "1"));
  }, [allData]);
  const handleExistingMaintenanceProject = () => {
    const permission = checkPermissionsByModule(roles, 25, 3);
    if (permission) {
      navigate(`${configure.appUrl}work/edit-maintenance-project/#existing`);
    } else {
      setAccessDenied(true);
    }
  };
  const handleAddMaintenanceProject = () => {
    const permission = checkPermissionsByModule(roles, 25, 3);
    if (permission) {
      navigate(`${configure.appUrl}work/edit-maintenance-project/#new`);
    } else {
      setAccessDenied(true);
    }
  };
  return (
    <div>
      <div id="support-header" className="mb-4 align-items-center row">
        <div className="pr-0 support-status-part general-status-part col-md-9">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-start w-100 text-center align-items-center gap-3">
              <a
                className={`text-green pt-2 px-0 rounded work-status general-task-status ${
                  status == "all" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("all");
                  setData(allData);
                }}
              >
                <h4>{allData?.length}</h4>
                <h4>All</h4>
              </a>
              <a
                className={`text-green pt-2 px-0 rounded work-status general-task-status ${
                  status == "not" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("not");
                  setData(allData?.filter((obj) => obj.status == "0"));
                }}
              >
                <h4>{allData?.filter((obj) => obj.status == "0")?.length}</h4>
                <h4>Not Started</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "in-progress" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("in-progress");
                  setData(allData?.filter((obj) => obj.status == "1"));
                }}
              >
                <h4>{allData?.filter((obj) => obj.status == "1")?.length}</h4>
                <h4>In Progress</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "hold" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("hold");
                  setData(allData?.filter((obj) => obj.status == "2"));
                }}
              >
                <h4>{allData?.filter((obj) => obj.status == "2")?.length}</h4>
                <h4>On Hold</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "cancel" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("cancel");
                  setData(allData?.filter((obj) => obj.status == "3"));
                }}
              >
                <h4>{allData?.filter((obj) => obj.status == "3")?.length}</h4>
                <h4>Cancelled</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "finish" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("finish");
                  setData(allData?.filter((obj) => obj.status == "4"));
                }}
              >
                <h4>{allData?.filter((obj) => obj.status == "4")?.length}</h4>
                <h4>Finished</h4>
              </a>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end pl-0 support-action-part col-md-3">
          <div className="text-md-end">
            <a
              onClick={() => setOpen(!isOpen)}
              className="s btn text-white btn-save btn-label me-2"
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Project
            </a>
            {isOpen && (
              <ul
                className="dropdown-menu mt-1 d-flex flex-column"
                style={{ right: "25%" }}
              >
                <div className="">
                  <li className="mb-1 dropdown-item cursor-pointer">
                    {/* <a onClick={handleAddProject}>
                     */}
                    <a onClick={handleAddMaintenanceProject}>
                      New Project
                      <span className="ps-1">
                        <i className="bi bi-file-earmark-spreadsheet"></i>
                      </span>
                    </a>
                  </li>
                  <li className="mb-1 dropdown-item cursor-pointer">
                    <a
                      className="nav-link"
                      onClick={handleExistingMaintenanceProject}
                    >
                      Existing Project
                      <span className="ps-2">
                        <i className="bi bi-box-arrow-in-right"></i>
                      </span>
                    </a>
                  </li>
                </div>
              </ul>
            )}
            <button
              className="s btn btn-red btn-label"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button>
          </div>
        </div>
      </div>
      <Row>
        <div className="col-md-12 my-4 d-flex">
          <div className="col-md-6 d-flex justify-content-start align-items-center">
            <div className="col-md-2 d-flex justify-content-start align-items-center">
              <select
                className="s me-4 form-select"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={(e) => setPageSize(e.target.value)}
              >
                {[10, 25, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-6 d-flex justify-content-end align-items-center">
            <div className="search-box">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="s form-control rounded "
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fix-DR-project-header" : "fix-table-header"
            } `}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className;
                  return (
                    <th
                      key={index}
                      className={` col-t-${index + 1} ${classNames}`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div
                        className={`position-relative d-flex ${
                          column.isShortIcon
                            ? "justify-content-between"
                            : "justify-content-center"
                        }`}
                      >
                        {index === 0 && <span></span>}
                        <span
                          style={{
                            position: index === 0 ? "absolute" : "",
                            left: index === 0 ? "45%" : "",
                          }}
                        >
                          {column.render("Header")}
                        </span>
                        {column.isShortIcon ? (
                          <span
                            style={{
                              position: index != 0 ? "absolute" : "",
                              right: index != 0 ? "0" : "",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${
                                column.isSorted && !column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${
                                column.isSorted && column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                          </span>
                        ) : null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody className="fix-table" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => (
                    <td
                      key={index}
                      className={`t-col-${index + 1} ${cell.column.className}`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
            {page.length == 0 && (
              <tr style={{ backgroundColor: "unset" }}>
                <td className="text-center" colSpan={10}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  );
}

const MaintenanceProject = ({ projectType }) => {
  const [verticalActiveTab, setverticalActiveTab] = useState("7");
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [viewId, setViewId] = useState("");
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [projectId, setProjectId] = useState("");
  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setmodal_fullscreen(false), setAddTask(false);
  });

  //meta title
  document.title = "Dedicated Resources | Zithas Technologies";
  const [isLoading, setLoading] = useState(false);
  const [modal_Access, setAccessDenied] = useState(false);
  const [addTask, setAddTask] = useState(false);
  const [reNewProject, setRenewProject] = useState(false);
  const userId = localStorage.getItem("auth_id");
  const token = secureLocalStorage.getItem("auth_token");
  const roles = useSelector((state) => state?.Roles?.apiData);
  const [projectDetail, setProjectDetail] = useState({});
   const [renewLogs, setRenewLogs] = useState(false)
  const [contractOption, setContractOption] = useState([])
  const [contract, setContract] = useState(null)
  const [scopes, setScopes] = useState([])
  const [selectedDate, setSelectedDate] = useState("")
  const [selectedPeriod, setSelectedPeriod] = useState(null)
  const [calculatedEndDate, setCalculatedEndDate] = useState("")
  const [paymentSchedules, setPaymentSchedules] = useState([])
  const [paymentPercents, setPaymentPercents] = useState([])
  const [completionDates, setCompletionDates] = useState([])
  const [renewProjectDetails, setRenewProjectDetails] = useState({})
  const [renewLogsData, setRenewLogsData] = useState({})
  const [renewLogsProject_name, setRenewLogsProject_name] = useState("")

  const onChangeStatusProject = async (id, type, status) => {
    const permission = checkPermissionsByModule(roles, 25, 4);
    if (permission) {
      Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: `${
          type == 1
            ? `You want to ${status == 0 ? "Play Project" : "Pause Project"}`
            : "You want to change status."
        }`,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const formEntries = {
            user_id: localStorage.getItem("auth_id"),
            role_id: secureLocalStorage.getItem("auth_role"),
            project_id: id,
            status: status,
            type: type,
            project_type: 3,
          };
          const response = await FetchPostData(
            toggleLoading,
            "changeProjectStatus",
            "",
            formEntries
          );
          if (response.data?.success) {
            Swal.fire({
              icon: "success",
              title: "Project Status Updated Successfully",
            }).then((data) => {
              setData(response?.data?.data?.project2);
              setAllData(response?.data?.data?.project2);
            });
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };
  const onDelete = async (id) => {
    const permission = checkPermissionsByModule(roles, 25, 5);
    if (permission) {
      Swal.fire({
        title: "Are you sure?",
        text: "you want to delete this Project!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const formDatas = {
            project_id: id,
            user_id: localStorage?.getItem("auth_id"),
            project_type: 3,
          };
          const response = await FetchPostData(
            toggleLoading,
            "delete_project",
            secureLocalStorage.getItem("auth_token"),
            formDatas
          );
          if (response?.data?.success) {
            Swal.fire({
              icon: "success",
              text: "Project deleted successfully",
            });
            setData(response?.data?.data?.project2);
            setAllData(response?.data?.data?.project2);
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };
  const handleAdd = (id) => {
    const permission = checkPermissionsByModule(roles, 25, 4);
    if (permission) {
      setProjectId(id);
      setAddTask(true);
    } else {
      setAccessDenied(true);
    }
  };
  const onViewPorject = async (obj) => {
    const res = await fetchData(toggleLoading, `projectView/${obj.id}`, token);
    if (res?.success) {
      setProjectDetail(res?.data?.project[0]);
      setmodal_fullscreen(true);
    }
  };


  const staff = [
    { label: "Rahul", value: "Rahul" },
    { label: "Divyansh", value: "Divyansh" },
    { label: "Mohit", value: "Mohit" },
  ];
  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const fetchProjects = async () => {
    const formEntries = {
      user_id: userId,
      role_id: secureLocalStorage.getItem("auth_role"),
      type: 3,
    };
    const res = await FetchPostData(
      toggleLoading,
      "projects",
      token,
      formEntries
    );
    if (res?.data?.success) {
      setData(res?.data?.data?.project2);
      setAllData(res?.data?.data?.project2);
    }
  };

  useEffect(() => {
    if (projectType == 3) {
      fetchProjects();
    }
  }, [projectType]);

   // Renew Process
  const handleRenew = async id => {
    try {
      if (!contractOption.length) {
        await fetchProjectData()
      }
      const res = await fetch(`${configure.apiUrl}/projectView/${id}`)
      const json = await res.json()
      const projectData = json?.data?.project?.[0]
      if (projectData) {
        setRenewProjectDetails(projectData)
        const scopesArray = Array.isArray(projectData.project_scope)
          ? projectData.project_scope
          : projectData.project_scope?.split("@#").filter(Boolean) || [""]
        setScopes(scopesArray.length > 0 ? scopesArray : [""])
        const matchedContract = contractOption.find(
          opt => opt.value === projectData.contract_id
        )
        if (matchedContract) {
          setContract(matchedContract)
          setPaymentSchedules( [""])
          setPaymentPercents(
            matchedContract.payment_percent?.split("@#") || [""]
          )
          setCompletionDates(
            matchedContract.completion_dates?.split("@#") || [""]
          )
        } else {
          setContract(null)
          setScopes([""])
          setPaymentSchedules([""])
          setPaymentPercents([""])
          setCompletionDates([""])
        }
        setRenewProject(true)
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        text: "An error occurred while fetching project data.",
      })
    }
  }

  const updatePaymentSchedule = (index, value) => {
    const updated = [...paymentSchedules]
    updated[index] = value
    setPaymentSchedules(updated)
  }

  const updatePaymentPercent = (index, value) => {
    const newSchemes = [...paymentPercents]
    newSchemes[index] = value
    setPaymentPercents(newSchemes)
  }

  const viewRenewLogs = async id => {
    try {
      const res = await axios.get(
        `${configure.nodeApi}/renewMaintenanceProject/logs/${id}`
      )
      setRenewLogsData(res.data.data)
      setRenewLogsProject_name(res.data.project_name)
      setRenewLogs(true)
    } catch (err) {
      Swal.fire({
        icon: "error",
        text: "An error occurred while fetching renewal logs.",
      })
    }
  }
  const columns = useMemo(
    () =>
      MaintenanceProjectColumns(
        onChangeStatusProject,
        onDelete,
        handleAdd,
        onViewPorject,
        handleRenew,
        viewRenewLogs
      ),
    []
  )

  const renewOptions = [
    { value: 1, label: "1 Month" },
    { value: 3, label: "3 Months" },
    { value: 6, label: "6 Months" },
    { value: 12, label: "1 Year" },
  ]

  const fetchProjectData = async () => {
    const res = await fetchData(toggleLoading, "projectRelatedData", token)
    if (res?.success) {
      const { data } = res
      const { contract } = data
      const createOptions = (items, label, value) =>
        items?.map(item => ({ label: item?.[label], value: item?.[value] }))
      setContractOption(
        contract?.map(obj => ({
          value: obj?.id,
          label: `${obj?.id}-${obj?.company_name}-${obj?.service}`,
          project_scope: obj?.project_scope,
          payment_schedule: obj?.payment_schedule,
          payment_percent: obj?.payment_percent,
          completion_dates: obj?.completion_dates,
        }))
      )
    }
  }

  useEffect(() => {
    fetchProjectData()
  }, [])

  const handleDateChange = e => {
    const date = e.target.value
    setSelectedDate(date)
    if (selectedPeriod?.value) {
      const end = moment(date)
        .add(selectedPeriod.value, "months")
        .format("YYYY-MM-DD")
      setCalculatedEndDate(end)
    }
  }

  const handlePeriodChange = option => {
    setSelectedPeriod(option)
    if (selectedDate) {
      const end = moment(selectedDate)
        .add(option.value, "months")
        .format("YYYY-MM-DD")
      setCalculatedEndDate(end)
    }
  }

  const addScopeField = () => {
    setScopes(prev => [...prev, ""])
  }

  const updateScope = (index, value) => {
    const updated = [...scopes]
    updated[index] = value
    setScopes(updated)
  }

  const removeScope = index => {
    const updated = [...scopes]
    updated.splice(index, 1)
    setScopes(updated)
  }

  const submitRenewal = async () => {
    try {
      // Validate required fields
      if (!selectedDate || !contract) {
        Swal.fire({
          icon: "warning",
          text: "Please fill in the Renewal Start Date and Select Contract fields.",
        })
        return
      }
      setLoading(true)
      // Prepare the renewal data
      const renewalData = {
        project_id: renewProjectDetails.id,
        months: selectedPeriod.value,
        user_id: localStorage.getItem("auth_id"),
        start_date: selectedDate,
        end_date: calculatedEndDate,
        contract_id: contract.value,
        project_scope: scopes.join("@#"),
        payment_schedule: paymentSchedules.join("@#"),
        payment_percent: parseInt(paymentPercents.join("@#")),
        completion_dates: completionDates.join("@#"),
      }

      const response = await axios.post(
        `${configure.nodeApi}/renewMaintenanceProject`,
        renewalData
      )

      if (response.data.status == true) {
        Swal.fire({
          icon: "success",
          text: "Project renewed successfully.",
        })
        setLoading(false)
        setRenewProject(false)
        await fetchProjects()
      } else {
        setLoading(false)
        Swal.fire({
          icon: "warning",
          text: response.data.message,
        })
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        text: "An error occurred while renewing the project.",
      })
    } finally {
      setLoading(false)
    }
  }

  const paymentSchemeOptions = [
    { value: "1", label: "Monthly" },
    { value: "2", label: "Weekly" },
    { value: "3", label: "Half Monthly" },
  ]

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="">
        <Container fluid>
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setData={setData}
                      roles={roles}
                      allData={allData}
                      setAccessDenied={setAccessDenied}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Task  */}
      <div className={`note-sticky-form ${addTask ? "d-block" : "d-none"}`}>
        <Draggable>
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "10%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Add Task</h5>
              <button
                type="button"
                onClick={() => {
                  setAddTask(false);
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>

            <AddTask projectId={projectId} />
          </ResizableBox>
        </Draggable>
      </div>

      {/* // View Project Modal  */}
      <Modal size="xl" isOpen={modal_fullscreen} className="modal-fullscreen">
        <div className="modal-header mb-0">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <div className="col-6 d-flex align-items-center">
              <h5 className=" modal-title mt-0">View Project Details</h5>
            </div>
          </div>

          <button
            type="button"
            onClick={() => {
              setmodal_fullscreen(false);
            }}
            className="ms-4"
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <span
              aria-hidden="true"
              style={{ color: "#bf1e30", fontSize: "28px", lineHeight: "1px" }}
            >
              {" "}
              &times;{" "}
            </span>
          </button>
        </div>

        <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
          <Row className="gx-4 justify-content-between">
            <Col md="2" className="side-tab h-100 py-3 bd-fixed-sidetab">
              <Nav pills className="flex-column">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "7",
                    })}
                    onClick={() => {
                      toggleVertical("7");
                    }}
                  >
                    Basic Project Details
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2");
                    }}
                  >
                    Milestones
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleVertical("3");
                    }}
                  >
                    Tasks
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "4",
                    })}
                    onClick={() => {
                      toggleVertical("4");
                    }}
                  >
                    Notes
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "5",
                    })}
                    onClick={() => {
                      toggleVertical("5");
                    }}
                  >
                    Activity Log
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "6",
                    })}
                    onClick={() => {
                      toggleVertical("6");
                    }}
                  >
                    Credential
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="10" className="bd-right-side-tab">
              <div className="px-4 h-100 pl-0">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="7">
                    <ProjectOverview projectDetail={projectDetail} />
                  </TabPane>
                  <TabPane tabId="3">
                    <ViewTasks
                      verticalActiveTab={verticalActiveTab}
                      toggleLoading={toggleLoading}
                      projectDetail={projectDetail}
                    />
                  </TabPane>
                  <TabPane tabId="4">
                    <Notes
                      verticalActiveTab={verticalActiveTab}
                      toggleLoading={toggleLoading}
                      edit={false}
                      projectId={projectDetail?.id}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <Milestones
                      verticalActiveTab={verticalActiveTab}
                      toggleLoading={toggleLoading}
                      edit={false}
                      projectId={projectDetail?.id}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <ActivityLog
                      verticalActiveTab={verticalActiveTab}
                      type={"edit"}
                      projectId={projectDetail?.id}
                    />
                  </TabPane>
                  <TabPane tabId="6">
                    <Credential projectDetail={projectDetail} />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>

      
      <Modal
        isOpen={renewLogs}
        toggle={() => setRenewLogs(false)}
        size="xl"
        centered
        style={{ maxWidth: "95vw", width: "95vw" }}
      >
        <ModalHeader toggle={() => setRenewLogs(false)} className="text-purple">
          Project Renewal Logs:{" "}
          <span className="text-primary fw-bold">{renewLogsProject_name} </span>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <Table bordered hover responsive striped>
              <thead>
                <tr>
                  <th className="text-center">Sr. No</th>
                  <th className="text-center">Start Date</th>
                  <th className="text-center">End Date</th>
                  <th className="text-center">Renewal Date</th>
                  <th className="text-center">Renew Start Date</th>
                  <th className="text-center">Renew End Date</th>
                  <th className="text-center">Renewal Duration</th>
                  {/* <th className="text-center">Payment Type</th> */}
                  <th className="text-center">Payment Dates</th>
                  {/* <th className="text-center">Project Scope</th> */}
                </tr>
              </thead>
              <tbody>
                {renewLogsData?.length > 0 ? (
                  renewLogsData.map((item, index) => (
                    <tr key={item.id + index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {moment(item.start_date).format("DD-MM-YYYY")}
                      </td>
                      <td className="text-center">
                        {moment(item.end_date).format("DD-MM-YYYY")}
                      </td>
                      <td className="text-center">
                        {moment(item.renewed_on).format("DD-MM-YYYY")}
                      </td>
                      <td className="text-center">
                        {moment(item.renew_startDate).format("DD-MM-YYYY")}
                      </td>
                      <td className="text-center">
                        {moment(item.renew_endDate).format("DD-MM-YYYY")}
                      </td>
                      <td className="text-center">
                        {item.renew_months + ` Months`}
                      </td>
                      {/* <td className="text-center">
                          {item.renew_paymentSchedule}
                        </td> */}
                      <td className="text-center" style={{ maxWidth: "220px" }}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "4px 8px",
                            fontSize: "13px",
                            textAlign: "left",
                          }}
                        >
                          {item?.renew_completionDates
                            ?.split("@#")
                            .map((date, i) => (
                              <div key={i}>
                                <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                                {moment(date).format("DD-MM-YYYY")}
                              </div>
                            ))}
                        </div>
                      </td>

                      {/* <td>
                          {item.renew_projectScope
                            ?.split("@#")
                            .map((line, i) => (
                              <div
                                key={i}
                                className="d-flex align-items-start mb-1"
                              >
                                <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                <span>{line}</span>
                              </div>
                            ))}
                        </td> */}
                    </tr>
                  ))
                ) : (
                  <tr className="text-center">
                    <td colSpan={12}>No Renewal Logs Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={reNewProject}
        toggle={() => setRenewProject(false)}
        size="xl"
        centered
        className="renew-project-modal"
      >
        <ModalHeader toggle={() => setRenewProject(false)}>
          <h5 className="modal-title mt-0 text-purple">Renew Project</h5>
        </ModalHeader>

        <ModalBody>
          <div className="col-md-12">
            {/* Initial Project Info */}
            <p className="mb-3">
              <span className="text-purple fw-bold">
                Initial Project Details
              </span>
            </p>
            <div className="row mb-2">
              <div className="col-md-6">
                <div className="mb-2 d-flex align-items-center">
                  <i className="mdi mdi-chevron-right text-primary me-1"></i>
                  <span className="fw-bold me-1 text-purple">
                    Project Name:
                  </span>
                  <span>{renewProjectDetails?.project_name || "N/A"}</span>
                </div>
                <div className="mb-2 d-flex">
                  <i className="mdi mdi-chevron-right text-primary me-1 mt-1"></i>
                  <span className="fw-bold me-1 text-purple">Customer:</span>
                  <span>{renewProjectDetails?.customer1 || "N/A"}</span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-2 d-flex align-items-center">
                  <i className="mdi mdi-chevron-right text-primary me-1"></i>
                  <span className="fw-bold me-1 text-purple">Start Date:</span>
                  <span>
                    {moment(renewProjectDetails?.startdate).format(
                      "DD-MM-YYYY"
                    ) || "N/A"}
                  </span>
                </div>
                <div className="mb-2 d-flex align-items-center">
                  <i className="mdi mdi-chevron-right text-primary me-1"></i>
                  <span className="fw-bold me-1 text-purple">End Date:</span>
                  <span>
                    {moment(renewProjectDetails?.enddate).format(
                      "DD-MM-YYYY"
                    ) || "N/A"}
                  </span>
                </div>
              </div>
            </div>

            {/* Renewal Inputs */}
            <div className="row mb-3">
              <p className="pt-3 mb-3">
                <span className="text-purple fw-bold">Add Renewal Details</span>
              </p>
              <div className="col-md-6">
                <label>
                  Renewal Start Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  required
                  value={
                    selectedDate
                      ? moment(selectedDate, "YYYY-MM-DD", true).isValid()
                        ? moment(selectedDate).format("YYYY-MM-DD")
                        : ""
                      : ""
                  }
                  onChange={handleDateChange}
                />
              </div>
              <div className="col-md-6">
                <label>
                  Renewal Period <span className="text-danger">*</span>
                </label>
                <Select
                  options={renewOptions}
                  styles={colourStyles}
                  required
                  classNamePrefix="select"
                  placeholder="Select"
                  value={selectedPeriod}
                  onChange={handlePeriodChange}
                />
              </div>
            </div>

            {/* Contract + End Date */}
            <div className="row mb-4">
              <div className="col-md-6">
                <label>
                  Select Contract <span className="text-danger">*</span>
                </label>
                <Select
                  placeholder="Select contract"
                  required
                  classNamePrefix="select"
                  options={contractOption}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  value={contract}
                  onChange={data => {
                    setContract(data)
                    const scopesArray = Array.isArray(data.project_scope)
                      ? data.project_scope
                      : data.project_scope?.split("@#").filter(Boolean) || [""]
                    setScopes(scopesArray.length > 0 ? scopesArray : [""])
                    setPaymentSchedules([""])
                    setPaymentPercents([""])
                    setCompletionDates([""])
                  }}
                />
              </div>
              <div className="col-md-6">
                <label>Calculated End Date</label>
                <input
                  type="text"
                  className="form-control"
                  value={calculatedEndDate}
                  disabled
                />
              </div>
            </div>

            {/* Scope & Payment Schedule Section */}
            {contract && (
              <div className="row mb-4">
                {/* Scopes */}
                <div className="col-md-12 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label>
                      Scopes <span className="text-danger">*</span>
                    </label>
                    <button className="btn btn-purple" onClick={addScopeField}>
                      Add More
                    </button>
                  </div>
                  {scopes.map((scope, i) => (
                    <div className="row align-items-center mb-2" key={i}>
                      <div className="col-md-11">
                        <input
                          type="text"
                          className="form-control"
                          value={scope}
                          onChange={e => updateScope(i, e.target.value)}
                          placeholder={`Scope ${i + 1}`}
                        />
                      </div>
                      <div className="col-md-1 d-flex justify-content-end">
                        <button
                          className="btn btn-outline-danger"
                          onClick={() => removeScope(i)}
                          title="Delete scope"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Payment Schedule */}
                <div className="col-md-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label>
                      Payment Schedule <span className="text-danger">*</span>
                    </label>
                  </div>
                  {paymentSchedules.map((schedule, i) => (
                    <div className="row align-items-end mb-2" key={i}>
                      <div className="col-md-6">
                        <label>Schedule Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={schedule || ""}
                          onChange={e =>
                            updatePaymentSchedule(i, e.target.value)
                          }
                          placeholder={`Payment ${i + 1}`}
                        />
                      </div>
                      <div className="col-md-6">
                        <label>
                          Payment Scheme <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={paymentSchemeOptions}
                          styles={colourStyles}
                          classNamePrefix="select"
                          placeholder="Select"
                          value={paymentSchemeOptions.find(
                            option => option.value === paymentPercents[i]
                          )}
                          onChange={option =>
                            updatePaymentPercent(i, option.value)
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Footer Button */}
            <div className="text-end border-top pt-3">
              <button className="btn btn-purple" onClick={submitRenewal}>
                Renew Now
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Access Denied */}
      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  );
};

export default MaintenanceProject;
